import { Step, StepLabel } from '@mui/material';
import StepIcon from './StepIcon';

export interface IStepEnd {
    icon?: JSX.Element,
    key?: string | number,
    active: boolean
  }

const VerticalEndStep = (props: IStepEnd) => {
  const { icon, key, active } = props;  
  return (
    <>
      <Step key={key} expanded={true}>
        <StepLabel
          StepIconComponent={StepIcon}
          StepIconProps={{ icon, active}}>
        </StepLabel>
      </Step>
    </>
  );
  
};

export default VerticalEndStep;